angular.module("warsApp.directives").directive('dragOver', ['$parse', function ($parse) {
    return function (scope, element, attrs) {
        element.bind("dragover", function (event) {
            var attrHandler = $parse(attrs['dragOver']);

            attrHandler(scope, { $event: event });

            event.preventDefault();
        });
    };
}]);

angular.module("warsApp.directives").directive('dragLeave', ['$parse', function ($parse) {
    return function (scope, element, attrs) {
        element.bind("dragleave", function (event) {
            var attrHandler = $parse(attrs['dragLeave']);

            scope.$apply(function () {
                attrHandler(scope, { $event: event });
            });

            event.preventDefault();
        });
    };
}]);

angular.module("warsApp.directives").directive('dropOn', ['$parse', function ($parse) {
    return function (scope, element, attrs) {
        element.bind("drop", function (event) {
            var attrHandler = $parse(attrs['dropOn']);

            scope.$apply(function () {
                attrHandler(scope, { $event: event });
            });

            event.preventDefault();
        });
    };
}]);
